// noinspection JSUnusedGlobalSymbols
export default () => ({
    counts: {},
    draft: {
        address: {
            country: 34
        }
    },
    entities: {},
})
